'use client';
import { getDocumentUrl } from '@services/documentService';
import { DocumentType } from '../types/documentType';

export default async function onDocumentClick(documentType: DocumentType) {
  try {
    const url = await getDocumentUrl(documentType);

    const newWindow = window.open(url, '_blank');

    if (!newWindow) {
      // Popup was blocked, navigate in same tab instead
      window.location.href = url;
    }
  } catch (error) {
    console.error('Failed to fetch the document URL:', error);
  }
}
